const profanities = [
  "⒮⒠⒳",
  "@!@",
  "^^ㅣ발",
  "^^l발",
  "108새끼",
  "10넘",
  "10놈",
  "10발넘",
  "10발년",
  "10발놈",
  "10밸넘",
  "10밸놈",
  "10밸늠",
  "10버지",
  "10새기",
  "10새끼",
  "10새리",
  "10새야",
  "10새퀴",
  "10섹",
  "10쉑",
  "10쎄끼",
  "10쎈치",
  "10쎝치",
  "10앨넘",
  "10앨놈",
  "10앨늠",
  "10이다",
  "10창",
  "10챵",
  "10탱",
  "10팔년",
  "10팔놈",
  "10팔뇬",
  "10팔색",
  "10팔섹",
  "10팔쉑",
  "10팔연",
  "10할년",
  "10할연",
  "10JIL",
  "18넘",
  "18년",
  "18놈",
  "18뇬",
  "18눔",
  "18늠",
  "18새",
  "18새끼",
  "18세끼",
  "18섹",
  "18쉐",
  "18쉑",
  "18시끼",
  "18시키",
  "18쎄리",
  "18쒜끼",
  "18쒜리",
  "18쒝끼",
  "18씨끼",
  "18운영자",
  "18sus",
  "18x",
  "2씨8",
  "2C8",
  "2C팔",
  "2girls1cup",
  "4까시",
  "4까C",
  "4KKASI",
  "69전문",
  "가슴만져",
  "가슴빨아",
  "가슴빨어",
  "가슴조물락",
  "가슴주물럭",
  "가슴쪼물딱",
  "가슴쪼물락",
  "가슴핧아",
  "가슴핧어",
  "가튼넘",
  "가튼년",
  "가튼놈",
  "가튼뇬",
  "갇은넘",
  "갇은년",
  "갇은놈",
  "갇은뇬",
  "갈보",
  "강간",
  "같은넘",
  "같은년",
  "같은놈",
  "같은뇬",
  "같은새끼",
  "같은쌔",
  "개가든",
  "개가뜬",
  "개가턴",
  "개가툰",
  "개가튼",
  "개가튼년",
  "개가튼뇬",
  "개갇은",
  "개갈보",
  "개같",
  "개같은넘",
  "개같은년",
  "개같은뇬",
  "개걸레",
  "개고치",
  "개너마",
  "개너므",
  "개너미",
  "개넌",
  "개넘",
  "개녀나",
  "개년",
  "개노마",
  "개노무새끼",
  "개논",
  "개놈",
  "개뇨나",
  "개뇬",
  "개뇸",
  "개뇽",
  "개눔",
  "개느마",
  "개늠",
  "개때꺄",
  "개때끼",
  "개떡",
  "개떵",
  "개떼끼",
  "개똥",
  "개라슥",
  "개랙기",
  "개련",
  "개발남아",
  "개발뇬",
  "개보즤",
  "개보지",
  "개부달",
  "개부랄",
  "개부러럴",
  "개부럴",
  "개부뢀",
  "개부알",
  "개불랄",
  "개불알",
  "개붕알",
  "개삭구",
  "개새",
  "개새기",
  "개새끼",
  "ㄱㅐㅅㅐㄲl",
  "개색",
  "개색끼",
  "개샊",
  "개샛끼",
  "개샛키",
  "개샛킹",
  "개샛히",
  "개샜끼",
  "개생키",
  "개샠",
  "개샤끼",
  "개샤킥",
  "개샥",
  "개샹늠",
  "개세",
  "개세끼",
  "개세리",
  "개세키",
  "개섹",
  "개섹히",
  "개섺",
  "개셃",
  "개셋키",
  "개셐",
  "개셰리",
  "개솩",
  "개쇄",
  "개쇄기",
  "개쇄끼",
  "개쇅",
  "개쇅끼",
  "개쇅키",
  "개쇗",
  "개쇠리",
  "개쇸",
  "개쉐",
  "개쉐끼",
  "개쉐리",
  "개쉐키",
  "개쉑",
  "개쉑갸",
  "개쉑기",
  "개쉑꺄",
  "개쉑끼",
  "개쉑캬",
  "개쉑키",
  "개쉑히",
  "개쉢",
  "개쉨",
  "개쉬",
  "개쉬끼",
  "개쉬리",
  "개쉽",
  "개스끼",
  "개스키",
  "개습",
  "개습세",
  "개습쌔",
  "개싀기",
  "개싀끼",
  "개싀밸",
  "개싀킈",
  "개싀키",
  "개싏",
  "개싑창",
  "개싘",
  "개시끼",
  "개시퀴",
  "개시키",
  "개식기",
  "개식끼",
  "개식히",
  "개십",
  "개십새",
  "개십팔",
  "개싯기",
  "개싯끼",
  "개싯키",
  "개싴",
  "개쌍넘",
  "개쌍년",
  "개쌍놈",
  "개쌍눔",
  "개쌍늠",
  "개쌍연",
  "개쌍영",
  "개쌔",
  "개쌔꺄",
  "개쌔끼",
  "개쌕",
  "개쌕끼",
  "개쌰깨",
  "개썅",
  "개썅년",
  "개썅놈",
  "개썅늠",
  "개썅연",
  "개쎄",
  "개쎅",
  "개쎼키",
  "개쐐리",
  "개쒜",
  "개쒜끼",
  "개쒜리",
  "개쒝",
  "개쒝기",
  "개쒝꺄",
  "개쒝끼",
  "개쒝캬",
  "개쒝키",
  "개쒯",
  "개쒸",
  "개쒸빨놈",
  "개쒹기",
  "개쓉",
  "개쓰래기",
  "개쓰레기",
  "개씀",
  "개씁",
  "개씁년",
  "개씁블",
  "개씁쌔",
  "개씁쎄",
  "개씁자지",
  "개씌끼",
  "개씨끼",
  "개씨발",
  "개씨발넘",
  "개씨발놈",
  "개씨발뇸",
  "개씨부럴",
  "개씨블",
  "개씨팔",
  "개씨팕",
  "개씸",
  "개씹",
  "개씹창",
  "개씹팔",
  "개욘",
  "ㄱㅐㅈㅏ",
  "개자식",
  "개자지",
  "개잡것",
  "개잡년",
  "개잡놈",
  "개잡뇬",
  "개젓",
  "개젓가튼넘",
  "개젖",
  "개젗",
  "개졋",
  "개졎",
  "개조또",
  "개조옷",
  "개족",
  "개좃",
  "개좆",
  "개좇",
  "개지랄",
  "개지럴",
  "개창년",
  "개허러",
  "개허벌년",
  "개호러",
  "개호로",
  "개후라년",
  "개후라들놈",
  "개후라새끼",
  "개후랄",
  "개후레",
  "개후로",
  "개후장",
  "개ㅐ색",
  "걔섀끼",
  "걔잡넘",
  "걔잡년",
  "걔잡뇬",
  "거시기",
  "거지새끼",
  "거지쉐뀌",
  "거지쉑이",
  "거지쎄끼",
  "거지쒜리",
  "걸래가튼",
  "걸래가튼뇬",
  "걸래같은년",
  "걸래넘",
  "걸래년",
  "걸래놈",
  "걸레가튼넘",
  "걸레가튼뇸",
  "걸레같은년",
  "걸레같은놈",
  "걸레년",
  "걸레핀년",
  "게가튼",
  "게같은",
  "게너마",
  "게넘",
  "게년",
  "게노마",
  "게놈",
  "게뇨나",
  "게뇬",
  "게뇸",
  "게뇽",
  "게눔",
  "게늠",
  "게띠발넘",
  "게부랄",
  "게부럴",
  "게부알",
  "게새끼",
  "게새리",
  "게새키",
  "게색",
  "게색기",
  "게색끼",
  "게샛키",
  "게세꺄",
  "게세끼",
  "게이",
  "게자식",
  "게자지",
  "게잡넘",
  "게잡년",
  "게잡뇬",
  "게젓",
  "게좆",
  "게지랄놈",
  "계같은뇬",
  "계뇬",
  "계뇽",
  "계집련",
  "고자새끼",
  "고츄",
  "고환",
  "곧휴",
  "골빈련",
  "공지",
  "공지사항",
  "구넝",
  "구녕",
  "구녘",
  "구뇽",
  "구멍질",
  "궤놈",
  "궤부럴",
  "궤시끼",
  "궤시키",
  "궤쎅",
  "귀두",
  "그룹섹",
  "그지새끼",
  "그지새키",
  "그지색",
  "기집년",
  "김치남",
  "김치녀",
  "까진년",
  "깔보",
  "깔보넘",
  "깔보년",
  "깔보놈",
  "깔보뇬",
  "깨쉑",
  "깨쌔꺄",
  "깨쌔끼",
  "깨쌔리",
  "꺼추",
  "께세",
  "꼬추",
  "꼬치",
  "꼴페미",
  "꾸녕",
  "꾸뇽",
  "ㄴ1ㄱ1",
  "ㄴ1ㅁ1",
  "ㄴ1미",
  "ㄴ1에미",
  "ㄴ1ㅇH미",
  "나너먹을게",
  "나쁜쉑",
  "난자마셔",
  "난자먹어",
  "난자핧아",
  "난잡년",
  "남창",
  "내꺼빨아",
  "내꺼핧아",
  "내미랄",
  "내미럴",
  "내버지",
  "내자지",
  "내잠지",
  "내조지",
  "냄져",
  "너거애비",
  "너에미",
  "넴병",
  "노에미",
  "노옴",
  "누나강간",
  "누워라이년아",
  "누웠냐씨방새",
  "눈깔",
  "눈깔어좃만아",
  "눼기미",
  "뉘귀미",
  "뉘기미",
  "뉘김이",
  "뉘뮈",
  "뉘미",
  "뉘미랄",
  "뉘미럴",
  "뉘미롤",
  "뉘밀얼",
  "뉘밀할",
  "뉘어미",
  "뉘에미",
  "뉘이미",
  "뉘잉기미",
  "뉭기리",
  "뉭기미",
  "느검마",
  "느금마",
  "느금창년",
  "늬긔미",
  "늬기미",
  "늬미",
  "니귀미",
  "니그로",
  "ㄴㅣㄱㅣ",
  "니기리",
  "니기뮈",
  "니기미",
  "니기미씹",
  "니김이",
  "니머럴",
  "니뮈",
  "니뮈랄",
  "니뮈럴",
  "니믜",
  "니믜창",
  "니미",
  "니미랄",
  "니미럴",
  "니미쒸블",
  "니미씨펄넘",
  "니미좃",
  "니밀할",
  "니부랑",
  "니뽕",
  "니뽕좃",
  "니뿡",
  "니씨브랄",
  "니아범",
  "니아비",
  "니애미",
  "니애뷔",
  "니애비",
  "니앰",
  "니어미",
  "니에미",
  "니에비",
  "니엠",
  "ㄴㅣㅇㅣㅁㅣ",
  "니임이",
  "니조지다",
  "니죠때",
  "니할애비",
  "닉이미",
  "닉임이",
  "닌기미",
  "닐기랄년",
  "님이랄",
  "님이럴",
  "님이롤",
  "닝기리",
  "닝기미",
  "닝기미씹",
  "니OH미",
  "ㄴlㅁl",
  "다구리",
  "다리벌려",
  "다리벌리",
  "다리사이",
  "닳은년",
  "대가리",
  "대갈통",
  "대마초",
  "대영웅좃대갈",
  "대주까",
  "대준다",
  "대줄께",
  "대줄년",
  "더러운년",
  "더러운놈",
  "덜은새끼",
  "돈새끼",
  "돋같",
  "돋나",
  "돌아이",
  "돌으년",
  "돌은넘",
  "돌은새끼",
  "동생강간",
  "동성애자",
  "됻밥",
  "둇",
  "뒈져",
  "뒈질래",
  "뒤럴",
  "뒤로너어줘",
  "뒤질래",
  "뒷치기",
  "듸랄",
  "듸뢀",
  "듸발",
  "디랄",
  "디럴",
  "디뢀",
  "디발",
  "디발눔",
  "디방쉐",
  "디봘",
  "딸다리",
  "딸달이",
  "딸따뤼",
  "딸딸이",
  "딸쳐",
  "딸치",
  "때끼",
  "떠라이",
  "떡쳐라",
  "떡칠",
  "떼끼",
  "또라이",
  "똘추",
  "똘추년",
  "똘추놈",
  "똥",
  "똥구녁",
  "똥구뇽",
  "똥구멍",
  "똥꾸뇽",
  "똥년",
  "똥새끼",
  "뛰발",
  "뛰봘",
  "뜁새",
  "뜨발",
  "뜨벌",
  "뜨블",
  "띄랄",
  "띄발",
  "띄밸",
  "띄뱅",
  "띄벨",
  "띄불",
  "띕때",
  "띕새",
  "띕알",
  "띠껍",
  "띠뎅",
  "띠랄",
  "띠바",
  "띠바랄",
  "띠박",
  "띠발",
  "띠발넘",
  "띠발년",
  "띠발놈",
  "띠발뇬",
  "띠발자식",
  "띠방",
  "띠방새",
  "띠방세",
  "띠방쉐",
  "띠밸",
  "띠버럴",
  "띠벌",
  "띠벙",
  "띠벙세",
  "띠벨",
  "띠병",
  "띠볼",
  "띠봉",
  "띠봉세",
  "띠봉알",
  "띠부랄",
  "띠부랄놈",
  "띠부럴",
  "띠불",
  "띠불넘",
  "띠불년",
  "띠불놈",
  "띠붕",
  "띠붕세",
  "띠뷀",
  "띠브랄",
  "띠브럴",
  "띠블",
  "띠블넘",
  "띠빌",
  "띠이바",
  "띠이발",
  "띠이방",
  "띠이밸",
  "띠이벌",
  "띠이볼",
  "띠이불",
  "띠이붕",
  "띠이팔",
  "띠이펄",
  "띠이풀",
  "띠키",
  "띠파",
  "띠팔",
  "띠퍼",
  "띠펄",
  "띠풀",
  "띱",
  "띱데",
  "띱때",
  "띱때끼",
  "띱새",
  "띱세",
  "띱쉐",
  "띱쎄",
  "띱쒜",
  "띱할",
  "띱헐",
  "뤼미럴",
  "리미랄",
  "리미럴",
  "리미썅",
  "리얼섹",
  "립서비스",
  "링기미",
  "ㅁ1친놈",
  "마스터",
  "막간년",
  "막대쑤셔줘",
  "막대핥아줘",
  "막대핧아줘",
  "만져볼래",
  "만져주께",
  "만져줘",
  "만지고파",
  "만지는중",
  "만지면커진다",
  "맛간년",
  "맛없는년",
  "맛이간년",
  "망할새퀴",
  "매춘",
  "매친년",
  "매친놈",
  "매친뇬",
  "먹고보니내딸",
  "먹고보니누나",
  "먹고보니딸",
  "먹고보니똥개",
  "먹고보니엄마",
  "먹고보니응아",
  "먹고보니재수",
  "먹고보니처제",
  "먹고보니형수",
  "먹은넘",
  "먹은년",
  "먹은놈",
  "먹은뇬",
  "메갈년",
  "메췬년",
  "메췬놈",
  "메친넘",
  "메친년",
  "메친놈",
  "메친뇬",
  "멜리스",
  "목따",
  "몸뚱이줄께",
  "몸안에사정",
  "물확뺄",
  "뭬친년",
  "뭬친놈",
  "뮈칀",
  "뮈칀세리",
  "뮈칀세이",
  "뮈친",
  "뮈친년",
  "뮈친놈",
  "뮈친세리",
  "뮈친세이",
  "뮈친쉑이",
  "믜칭넘",
  "미랄",
  "미럴",
  "미륀넘",
  "미륀년",
  "미린넘",
  "미린년",
  "미이친뇬",
  "미진넘",
  "미진뇬",
  "미찬놈",
  "미찬뇬",
  "미췐년",
  "미췬",
  "미췬넘",
  "미췬년",
  "미췬놈",
  "미췬뇬",
  "미췬세리",
  "미췬세이",
  "미칀년",
  "미칀놈",
  "미치넘",
  "미치뇬",
  "미친",
  "미친구녕",
  "미친구멍",
  "미친넌",
  "미친넘",
  "미친년",
  "미친놈",
  "미친뇬",
  "미친뇽",
  "미친눔",
  "미친새끼",
  "미친색이",
  "미친섀리",
  "미친쇄리",
  "미친쇠리",
  "미친쉐이",
  "미친쌍",
  "미친쌍녕",
  "미친쌍놈",
  "미친쌍농",
  "미친쌍뇽",
  "미친쌔",
  "미친씨부랄",
  "미친씹후까시",
  "미튄",
  "미튄넘",
  "미튄년",
  "미틘년",
  "미티넘",
  "미틴",
  "미틴것",
  "미틴넘",
  "미틴년",
  "미틴놈",
  "미틴뇬",
  "밑구녕",
  "밑구멍",
  "밑꾸녕",
  "밑꾸뇽",
  "밑힌년",
  "㉥㉥ㅏ",
  "ㅂㅂㅏ구ㄹㅣ",
  "ㅂㅅ",
  "ㅂㅈ",
  "ㅂ지",
  "바그네",
  "바근가시네",
  "바주카자지",
  "박고빼고",
  "박고싶",
  "박을년",
  "밖에다쌀께",
  "발기",
  "발넘",
  "발년",
  "발정",
  "배위에싸죠",
  "배째",
  "배째라게세끼",
  "백보디",
  "백보지",
  "밸년",
  "밸놈",
  "뱅신시키",
  "버따리자지",
  "버러지",
  "버얼려서너어",
  "버쥐",
  "ㅂㅓ즤",
  "버지구녕",
  "버지구멍",
  "버지냄새",
  "버지따먹기",
  "버지뚫어",
  "버지뜨더",
  "버지물마셔",
  "버지벌렁벌렁",
  "버지벌려",
  "버지벌료",
  "버지빨아",
  "버지빨어",
  "버지썰어",
  "버지쑤셔",
  "버지털",
  "버지핧아",
  "버짓물",
  "버짓물마셔",
  "벌레년",
  "벌레놈",
  "벌레새기",
  "벌창같은년",
  "벗겨보니그날",
  "벗겨보니남자",
  "벗겨보니내딸",
  "벗겨보니숙모",
  "벗겨보니처재",
  "벗겨보니처제",
  "벗겨보니형수",
  "벙섹",
  "벨년",
  "벨놈",
  "벵신",
  "벼엉신",
  "변섹",
  "변태",
  "병닥",
  "병딱",
  "병ㅅ새",
  "병쉰",
  "병시나",
  "병신",
  "병신년",
  "병신놈",
  "병신새",
  "병신쪼다",
  "병씬",
  "보빨",
  "보슬아치",
  "보오지",
  "보우지",
  "보주ㅣ",
  "보쥐",
  "보즤",
  "보지",
  "보지구멍",
  "보지녀",
  "보지년",
  "보지뇬",
  "보지벌",
  "보지빨",
  "보지털",
  "보지핧어",
  "보짓",
  "보짓년",
  "보짓물",
  "보짓물마셔",
  "보징어",
  "보짖",
  "보찌",
  "보탱",
  "보털",
  "보텡",
  "봇털",
  "봉알",
  "봊이",
  "봊지",
  "보g",
  "보x",
  "보z",
  "뵤오지",
  "뵤즤",
  "뵤지",
  "부랄",
  "부럴",
  "부부교환",
  "불넘",
  "불알",
  "붕알",
  "붜지",
  "뷩딱",
  "뷰지년",
  "뷰지들",
  "븅쉰",
  "븅신",
  "브랄",
  "블알",
  "븽시",
  "빙띤",
  "빙신",
  "빠가십새",
  "빠가씹새",
  "ㅃㅏㄱㅜ",
  "빠구리",
  "빠굴",
  "빠굴이",
  "빠그리",
  "빠꾸리",
  "ㅃㅏㄹㅏ",
  "빨0r",
  "빨게하",
  "빨게해",
  "빨고시포",
  "빨고싶다",
  "빨기",
  "빨라줘",
  "빨아라",
  "빨아먹",
  "빨아봐",
  "빨아죠",
  "빨아주",
  "빨아줄",
  "빨아줘",
  "빨어봐",
  "빨어핥어박어",
  "빨자",
  "빽보디",
  "빽보비",
  "빽보지",
  "빽자지",
  "빽좌지",
  "뻐지",
  "뻐큐",
  "뻑뀨",
  "뻑큐",
  "뻨뀨",
  "뻨유",
  "뻨큐",
  "뼝신",
  "뽀뀨",
  "뽀르노",
  "뽀쥐",
  "뽀지",
  "뽀쮜",
  "뽕알",
  "뿡알",
  "삐꾸",
  "ㅃR",
  "ㅃr굴",
  "ㅅ1발",
  "ㅅㅂ",
  "ㅅㅂㄹㅁ",
  "ㅅ빩",
  "ㅅ시발",
  "사ㄱㄱㅏ",
  "사가리",
  "사갈탱이",
  "ㅅㅏㄲㅏ",
  "사까시",
  "사앙년",
  "사앙뉸",
  "사창가",
  "사카시",
  "사카치",
  "살까치",
  "삽입",
  "삽탱",
  "삿까시",
  "삿깟시",
  "상넘",
  "상년",
  "상노무",
  "상놈",
  "상놈쉑",
  "상뇬",
  "상늠",
  "상늠쉑",
  "새갸",
  "새귀",
  "새까",
  "새꺄",
  "새뀌",
  "새끠",
  "새끼",
  "새뤼",
  "ㅅㅐㄹㅣ",
  "새에퀴",
  "새캬",
  "새퀴",
  "새킈",
  "새키",
  "새ㅐ꺄",
  "색갸",
  "색귀",
  "색기",
  "색꺄",
  "색끼",
  "색들",
  "색수",
  "색스",
  "색쑤",
  "색쓰",
  "색ㅋㅑ",
  "색키",
  "색할",
  "색햐",
  "색휘",
  "색히",
  "샊꺄",
  "샊끼",
  "샙새",
  "샙세",
  "생퀴",
  "생키",
  "샠",
  "새X",
  "샤럽",
  "샤발",
  "샤앙년",
  "샵년",
  "샹넘",
  "샹년",
  "샹논",
  "샹놈",
  "샹뇬",
  "샹늠",
  "샹악년",
  "샹악연",
  "섀기",
  "섀꺄",
  "섀끼",
  "섀캬",
  "섀키",
  "서글넘",
  "서버",
  "선오브비치",
  "섬숭이",
  "섬짱깨",
  "성경험",
  "성관계",
  "성교",
  "성체위",
  "성체험",
  "성폭행",
  "성행위",
  "ㅅㅔㄱ",
  "세게빨아",
  "세꺄",
  "세뀌",
  "세끠",
  "세끼",
  "ㅅㅔㄹㅣ",
  "ㅅㅔㅅ",
  "세액스",
  "세에끼",
  "세에쓰",
  "세에엑스",
  "세엑",
  "세엑수우",
  "세엑스",
  "세캬",
  "세퀴",
  "세키",
  "섹ㄱ기",
  "섹꺄",
  "섹끼",
  "섹들",
  "섹뜨",
  "섹보지",
  "섹수",
  "섹슈",
  "섹스",
  "섹스하자",
  "섹스해",
  "섹쑤",
  "섹쓰",
  "섹키",
  "섹하고",
  "섹하구",
  "섹하자",
  "섹하장",
  "섹하쟈",
  "섹한번",
  "섹할",
  "섹해",
  "섹히",
  "섹e스",
  "섹s",
  "셁기",
  "셁끼",
  "셐기",
  "셰끼",
  "셰리",
  "소추새끼",
  "소추소심",
  "쇄기",
  "쇄뀌",
  "쇄끼",
  "쇄이",
  "쇄키",
  "쇅꺄",
  "쇅끼",
  "쇅수",
  "쇅스",
  "쇅쑤",
  "쇅쓰",
  "쇅키",
  "쇅햐",
  "쇍끼",
  "쇗키",
  "쇠뀌",
  "쇠끼",
  "수셔",
  "숩삭키",
  "쉐꺄",
  "쉐뀌",
  "쉐끼",
  "쉐뤼",
  "쉐리",
  "쉐엑",
  "쉐퀴",
  "쉐키",
  "쉐팔",
  "쉐히",
  "쉑",
  "쉑갸",
  "쉑꺄",
  "쉑끼",
  "쉑수",
  "쉑스",
  "쉑쑤",
  "쉑쓰",
  "쉑캬",
  "쉑키",
  "쉑햐",
  "쉑히",
  "쉡발",
  "쉡세",
  "쉣끼",
  "쉣더뻑",
  "쉣키",
  "쉨기",
  "쉨끼",
  "쉨캬",
  "쉬28",
  "쉬8",
  "쉬꺄",
  "쉬끼",
  "쉬댕",
  "쉬뎅",
  "쉬바냔",
  "쉬바넘",
  "쉬바녀",
  "쉬바년",
  "쉬바노마",
  "쉬바놈",
  "쉬바뇬",
  "쉬바뇽",
  "쉬바눔",
  "쉬바늠",
  "쉬바랄",
  "쉬바련",
  "쉬바상",
  "쉬바새",
  "쉬바색",
  "쉬바섀",
  "쉬바세",
  "쉬바섹",
  "쉬바셰",
  "쉬바쉐",
  "쉬바쉑",
  "쉬바시",
  "쉬바식",
  "쉬바싯",
  "쉬바쌍",
  "쉬바쌔",
  "쉬바쎄",
  "쉬바알",
  "쉬바잡",
  "쉬발",
  "쉬발년",
  "쉬방",
  "쉬방쉐이",
  "쉬밸",
  "쉬밸년",
  "쉬뱅",
  "쉬뱔뇬",
  "쉬벌",
  "쉬벌년",
  "쉬벧",
  "쉬벨",
  "쉬벨뇬",
  "쉬볼",
  "쉬봘",
  "쉬부",
  "쉬부랄",
  "쉬부랄조또",
  "쉬불",
  "쉬불탱",
  "쉬붕",
  "쉬브랄",
  "쉬브럴",
  "쉬블",
  "쉬빌",
  "쉬빠",
  "쉬빡",
  "쉬빨",
  "쉬뺄",
  "쉬뻘",
  "쉬이8",
  "쉬이바",
  "쉬이발",
  "쉬이방",
  "쉬이밸",
  "쉬이벌",
  "쉬이부",
  "쉬이불",
  "쉬이붕",
  "쉬이빡",
  "쉬이빨",
  "쉬이뺄",
  "쉬이뻘",
  "쉬이팔",
  "쉬이펄",
  "쉬이풀",
  "쉬키",
  "쉬파",
  "쉬파새",
  "쉬파색",
  "쉬파쌔",
  "쉬파쌕",
  "쉬팍",
  "쉬팔",
  "쉬팕",
  "쉬팛",
  "쉬팡",
  "쉬퍼얼",
  "쉬펄",
  "쉬펄넘",
  "쉬펄년",
  "쉬펄놈",
  "쉬펄뇬",
  "쉬펄늠",
  "쉬펑",
  "쉬퐁",
  "쉬풀",
  "쉭빨",
  "쉭뻘",
  "쉭셰리",
  "쉭팔",
  "쉻알",
  "쉽8",
  "쉽년",
  "쉽뇬",
  "쉽땍기",
  "쉽땡구리",
  "쉽발",
  "쉽빨",
  "쉽뻘",
  "쉽ㅅㅐ",
  "쉽생구리",
  "쉽샤퀴",
  "쉽ㅅㅔ",
  "쉽셋",
  "쉽쉐",
  "쉽쉑",
  "쉽쌔",
  "쉽썌",
  "쉽쎄",
  "쉽쎅",
  "쉽알",
  "쉽앨",
  "쉽쟁이",
  "쉽질",
  "쉽탱",
  "쉽탱구리",
  "쉽팔",
  "쉽펄",
  "쉽할이",
  "쉿새",
  "쉿세",
  "슈발",
  "슈ㅟ발",
  "슈ㅣㅂ발",
  "슈ㅣ발",
  "슈ㅣ발년",
  "슙발",
  "스끼",
  "스댕",
  "스뎅",
  "스바랄",
  "스발",
  "스벌",
  "스벌놈",
  "스벌자식",
  "스벨",
  "스불",
  "스빌",
  "스빨",
  "스빵",
  "스뻘",
  "스뻥",
  "스와핑",
  "스팔",
  "스팔개",
  "스팔넘",
  "스팔년",
  "스팔놈",
  "스팔뇬",
  "스팔새",
  "스팔쌔",
  "스패킹",
  "스팽",
  "스팽킹",
  "스펄",
  "스펑",
  "습새",
  "습세",
  "습탱",
  "습팔",
  "싀발",
  "싀발놈",
  "싀발로모",
  "싀방",
  "싀밸",
  "싀벌",
  "싀벨",
  "싀보랄",
  "싀봉",
  "싀빨",
  "싀뻘년",
  "싀팍",
  "싀팔",
  "싁팍",
  "싑년",
  "싑발",
  "싑샤퀴",
  "싑세",
  "싑알",
  "싑앨",
  "싑얄",
  "싑질",
  "싓팔",
  "시28",
  "시8",
  "시글년",
  "시뀌",
  "ㅅㅣㄲㅣ",
  "ㅅㅣ달년",
  "시댕",
  "시댕뇬",
  "시댕이",
  "시뎅",
  "시뗑",
  "ㅅㅣㅂㅏ",
  "시바ㄹ",
  "시바라",
  "시바라마",
  "시바새기",
  "ㅅㅣ박",
  "시발",
  "시발넘",
  "시발년",
  "시발놈",
  "시발뇬",
  "시발눔",
  "시발늠",
  "시발라마",
  "시발럼",
  "시발롬",
  "시발새끼",
  "시발운영자",
  "시밝",
  "시밟",
  "시밠",
  "시밣",
  "시방넘",
  "시방녀",
  "시방년",
  "시방놈",
  "시방뇬",
  "시방새",
  "시방세",
  "시방쉐",
  "시방시불",
  "시밮",
  "시밯",
  "시밸",
  "시뱅",
  "시뱅넘",
  "시뱅년",
  "시뱅놈",
  "시뱅뇬",
  "시뱔",
  "시뱜",
  "시벌",
  "시벌넘",
  "ㅅㅣ벨",
  "시벨넘",
  "시벵",
  "ㅅㅣㅂㅗㅏㄹ",
  "시볼너아",
  "시볼뇬",
  "시봉세",
  "시봘",
  "시봟",
  "시부랄",
  "시부랄넘",
  "시부랄녀언",
  "시부랄년",
  "시부랄놈",
  "시부랄뇬",
  "시부랑",
  "시부럴",
  "시부리",
  "시불",
  "시불년",
  "시불놈",
  "시불탱",
  "시불팅",
  "시불헐",
  "시붕",
  "시뷀",
  "시브랄",
  "시블",
  "시블넘",
  "시블년",
  "시빌",
  "시빠련",
  "시빠바조쿠나",
  "ㅅㅣ빨",
  "시빨년",
  "시빨놈",
  "시빵",
  "시뻥",
  "시쎄이",
  "시ㅇ브랄녀",
  "시아눔",
  "시앙넘",
  "시앙년",
  "시앙놈",
  "시앙눔",
  "시양넘",
  "시양년",
  "시양놈",
  "시양눔",
  "시이8",
  "시이바",
  "시이발",
  "시이방",
  "시이밸",
  "시이벌",
  "시이부",
  "시이불",
  "시이붕",
  "시이빡",
  "시이팍",
  "시이팔",
  "시이펄",
  "시이풀",
  "ㅅㅣ입팔",
  "ㅅㅣㅋㅣ",
  "ㅅㅣㅍㅏ",
  "시파늠",
  "시파새",
  "시파쌔",
  "ㅅㅣ팍",
  "시팍년",
  "시팍새끼",
  "시팏",
  "시팔",
  "시팔넘",
  "시팔년",
  "시팔노마",
  "시팔놈",
  "시팔놈운영자",
  "시팔새끼",
  "시팔운영자",
  "시팕",
  "시팗",
  "시팡",
  "시팤",
  "ㅅㅣㅍㅓ",
  "시펄",
  "시펄년",
  "시펄놈",
  "시펑",
  "시퐁",
  "시퐈",
  "시퐉",
  "시퐐",
  "시퐐년",
  "시푈",
  "시풀",
  "시풀놈",
  "시ㅣ발",
  "식키",
  "식팍",
  "식팔",
  "식펄년",
  "신발너마",
  "실바시발놈",
  "실밸",
  "실프",
  "싥팕",
  "싫팛늠",
  "심년",
  "십8",
  "십8색",
  "십8섹",
  "십가튼",
  "십넘",
  "십녀",
  "십년",
  "십놈",
  "십뇬",
  "십데꺄",
  "십딱",
  "십때꺄",
  "십때끼",
  "십때키",
  "십땡",
  "십땡구리",
  "십떼끼",
  "십떼키",
  "십물",
  "십발새끼",
  "십발쌔꺄",
  "십밸",
  "십버지",
  "십부랄",
  "십부럴",
  "십사꾸",
  "십새",
  "십새까",
  "십새꺄",
  "십새끼",
  "십새캬",
  "십새키",
  "십색",
  "십색꺄",
  "십색끼",
  "십샹",
  "십섀",
  "십세",
  "십세이",
  "십셰리",
  "십쇄리",
  "십쇡기",
  "십쇼키",
  "십숑키",
  "십쉐",
  "십쉐리",
  "십쉑",
  "십쉑히",
  "십시끼",
  "십시퀴",
  "십쌔",
  "십쌔꺄",
  "십쌔끼",
  "십쌔키",
  "십쎄끼",
  "십쎼",
  "십씨키",
  "십앋",
  "십알",
  "십알넘",
  "십알놈",
  "십왈",
  "십우랄년",
  "십을년",
  "십자석",
  "십자슥",
  "십자식",
  "십장이",
  "십쟁이",
  "십좃",
  "십좌지",
  "십지랄",
  "십지럴",
  "십질",
  "십창",
  "십창녀",
  "십창년",
  "십챵",
  "십탱",
  "십탱구리",
  "십탱굴이",
  "십탱꾸리",
  "십탱아",
  "십탱이",
  "십텡구리",
  "십퉁",
  "십팔",
  "십팔년",
  "십팔놈",
  "십팔련",
  "십팔새끼",
  "십팔연",
  "십펄",
  "십하",
  "십할",
  "십할넘",
  "십할년",
  "십할놈",
  "십할뇬",
  "십할련",
  "십헐",
  "싯끼",
  "싯빨",
  "싯파",
  "싯팍",
  "싯팔",
  "싯팔뇬",
  "싯팟",
  "싯퐐",
  "싱발",
  "싲팔",
  "싴팔",
  "싵팔",
  "싶8",
  "싶알",
  "싶팔",
  "싶펄",
  "ㅅH끼",
  "ㅅHㄲI",
  "ㅆ!발",
  "ㅆ1",
  "ㅆ1바",
  "ㅆ1발",
  "ㅆ1밸",
  "ㅆ1벨",
  "ㅆ1팔",
  "ㅆㅂ",
  "ㅆㅂ놈",
  "ㅆㅂㄹㅁ",
  "ㅆ발",
  "ㅆㅂㄻ",
  "ㅆㅃ",
  "ㅆ엘",
  "ㅆㅍ",
  "싸게해줄게",
  "싸고시포",
  "싸근늼",
  "ㅆㅏㄲㅏ",
  "싸까씨",
  "싸냐",
  "싸바라마",
  "싸발",
  "싸발년",
  "싸뱔",
  "싸앙넘",
  "싸앙년",
  "싸앙놈",
  "싸앙뇽",
  "싸앙눔",
  "싸앙뉸",
  "싸앙늠",
  "싸죠",
  "싸줄게",
  "싹년",
  "쌉년",
  "쌍너엄",
  "쌍넌",
  "쌍넘",
  "쌍녀언",
  "쌍년",
  "쌍노무",
  "쌍노무운영자",
  "쌍놈",
  "쌍뇨나",
  "쌍뇬",
  "쌍뇸",
  "쌍뇽",
  "쌍눔",
  "쌍뉸",
  "쌍늠",
  "쌍보지",
  "쌍부랄",
  "쌍악연",
  "쌔기",
  "쌔까",
  "ㅆㅐㄲㅑ",
  "쌔뀌",
  "쌔끼",
  "쌔낑",
  "쌔리",
  "쌔밸년",
  "쌔캬",
  "쌔퀴",
  "쌔키",
  "쌕갸",
  "쌕꺄",
  "쌕끼",
  "쌕수",
  "쌕스",
  "쌕쑤",
  "쌕쓰",
  "쌕캬",
  "쌕히",
  "쌩보지",
  "쌰꺄",
  "쌰럽",
  "쌰발",
  "쌰발넘",
  "쌰발년",
  "쌰발놈",
  "쌰발라마",
  "쌰앙",
  "쌰앙넘",
  "쌰앙녀",
  "쌰앙년",
  "쌰앙놈",
  "쌰앙뇬",
  "쌰앙눔",
  "쌰앙뉸",
  "쌰앙늠",
  "썁슥",
  "썁식",
  "썁쌔리",
  "썅",
  "썅넘",
  "썅녀",
  "썅년",
  "썅놈",
  "썅뇬",
  "썅눔",
  "썅늠",
  "썅악",
  "썅악년",
  "썅앙년",
  "썅팔년",
  "썌꺄",
  "썌끼",
  "썌키",
  "썎끼",
  "써글",
  "써글넘",
  "써글년",
  "써글노무",
  "써글놈",
  "써글뇨나",
  "써글뇬",
  "써글눔",
  "써글늠",
  "써글세끼",
  "써글시키",
  "써버럴",
  "써벌",
  "썩을넘",
  "썩을년",
  "썩을노마",
  "썩을놈",
  "썩을뇨나",
  "썩을뇬",
  "썩을눔",
  "썩을늠",
  "썩을시끼",
  "썩을시키",
  "ㅆㅔㄱ",
  "쎄기",
  "ㅆㅔㄲㅑ",
  "ㅆㅔㄲㅣ",
  "쎄럽",
  "ㅆㅔㄹㅣ",
  "쎄엑",
  "쎄퀴",
  "쎄키",
  "쎅",
  "쎅수",
  "쎅스",
  "쎅쑤",
  "쎅쓰",
  "쎆끼",
  "쎆스",
  "ㅆㅖㄲㅣ",
  "쎽스",
  "쐉넘",
  "쐉년",
  "쐐뀌",
  "쐐끼",
  "쐐이",
  "쐑갸",
  "쐑꺄",
  "쐑들",
  "쐑수",
  "쐑스",
  "쐑쑤",
  "쐑쓰",
  "쐑캬",
  "쐬끼",
  "쑤셔",
  "쑤ㅣ벵아",
  "쑵년",
  "쑵새",
  "쒜",
  "쒜뀌",
  "쒜끠",
  "쒜끼",
  "쒜리",
  "쒜키",
  "쒝끼",
  "쒝수",
  "쒝쑤",
  "쒝쓰",
  "쒝캬",
  "쒭가튼",
  "쒭사꾸",
  "쒭새",
  "쒸뀌",
  "쒸댕",
  "쒸뎅",
  "쒸바라",
  "쒸박",
  "쒸발",
  "쒸방새",
  "쒸방쉐",
  "쒸부랄",
  "쒸부럴",
  "쒸뷰랄",
  "쒸뷰럴",
  "쒸빨",
  "쒸빨넘",
  "쒸빵세이",
  "쒸쌔",
  "쒸이",
  "쒸입새",
  "쒸키",
  "쒸파",
  "쒸팍",
  "쒸팔",
  "쒸팔넘",
  "쒸팔년",
  "쒸팔놈",
  "쒸팔뇬",
  "쒸팡",
  "쒸펄",
  "쓉년",
  "쓉새",
  "쓉새기",
  "쓉쌔",
  "쓉쌔끼",
  "쓉쎄",
  "쓉쎄끼",
  "쓉쒜",
  "쓉질",
  "쓉창",
  "쓉탱",
  "쓉팔넘",
  "쓉팔년",
  "쓉팔놈",
  "쓉팔뇬",
  "쓋파라",
  "쓰글넘",
  "쓰글년",
  "쓰글놈",
  "쓰글늠",
  "쓰댕",
  "쓰델",
  "쓰뎅",
  "쓰렉년",
  "쓰바",
  "쓰바새끼",
  "쓰발",
  "쓰방",
  "쓰봉",
  "쓰부랄",
  "쓰부럴",
  "쓰붕쉐",
  "쓰브랄",
  "쓰브랄쉽세",
  "쓰브럴",
  "쓰팔넘",
  "쓰팔년",
  "쓰팔놈",
  "쓰팔뇬",
  "씁새",
  "씁새끼",
  "씁세",
  "씁쉐",
  "씁쌔",
  "씁쎄",
  "씁쒜",
  "씁창",
  "씁탱",
  "씌28",
  "씌8",
  "씌댈",
  "씌댕",
  "씌델",
  "씌뎅",
  "씌바",
  "씌발",
  "씌발넘",
  "씌발쇄",
  "씌밝",
  "씌방",
  "씌밸",
  "씌밸넘",
  "씌뱅",
  "씌뱌",
  "씌벌",
  "씌벌련",
  "씌벌새기",
  "씌벨",
  "씌벵",
  "씌봉",
  "씌봘",
  "씌뵹",
  "씌블",
  "씌빨",
  "씌알",
  "씌파",
  "씌팏",
  "씌팔",
  "씌팕",
  "씌퐁",
  "씜쒜이",
  "씝",
  "씝년",
  "씝세",
  "씝쌔",
  "씝쎄",
  "씝알",
  "씝알놈",
  "씝알늠",
  "씝질",
  "씝창",
  "씝탱",
  "씝탱구리",
  "씝팔",
  "씝할",
  "씞",
  "씦알",
  "ㅆㅣ",
  "씨28",
  "씨8",
  "씨가랭넘",
  "씨가랭년",
  "씨가랭놈",
  "씨가랭뇬",
  "ㅆㅣㄲㅣ",
  "ㅆㅣㄷ",
  "씨댕",
  "씨댕년",
  "씨뎅",
  "씨땡",
  "씨뗑",
  "ㅆㅣㅂ",
  "ㅆㅣㅂㅏ",
  "씨바랄",
  "씨박",
  "씨박새",
  "씨발",
  "씨발넘",
  "씨발년",
  "씨발놈",
  "씨발뇬",
  "씨발뇸",
  "씨발라마",
  "씨발롬",
  "씨발병신",
  "씨발색",
  "씨발씨발",
  "씨밝",
  "씨밟",
  "씨밠",
  "씨밣",
  "씨밤",
  "씨밤년",
  "씨밥바",
  "씨밦",
  "씨방",
  "씨방새",
  "씨방세",
  "씨방쉐",
  "씨밮",
  "씨밯",
  "씨배랄",
  "씨밸",
  "씨밸넘",
  "씨밸년",
  "씨밸놈",
  "씨밸래미",
  "씨뱅",
  "씨뱅가리",
  "씨뱅놈",
  "씨뱅딱",
  "씨뱔",
  "씨버",
  "씨버럴",
  "씨벌",
  "씨벌넘",
  "씨벌년",
  "씨벌쉐이",
  "씨벙",
  "씨베랄",
  "씨베렐",
  "씨벧",
  "씨벨",
  "ㅆㅣ벨년",
  "씨벵",
  "씨보지",
  "씨볼",
  "씨볼년",
  "씨볼놈",
  "씨봉",
  "씨봉년",
  "씨봉쉐",
  "씨봉알",
  "씨봘",
  "씨봙",
  "씨봟",
  "씨봣넘",
  "씨봪",
  "씨뵐",
  "씨부랄",
  "씨부랠",
  "씨부럴",
  "씨부렁",
  "씨부롤",
  "씨불",
  "씨불넘",
  "ㅆㅣ불년",
  "씨불놈",
  "씨불뇬",
  "씨불알",
  "ㅆㅣ불얼",
  "씨불할",
  "씨불헐",
  "씨붕",
  "씨붤",
  "씨뷀",
  "씨뷩",
  "씨븅",
  "씨브",
  "씨브랄",
  "씨브럴",
  "씨브알",
  "씨블",
  "씨블넘",
  "씨블년",
  "씨븡",
  "씨븡새끼",
  "씨빠",
  "씨빡",
  "씨빨",
  "씨빨넘",
  "씨빯",
  "씨빳다",
  "씨빵",
  "씨뻘",
  "씨뻥",
  "씨뽀랄",
  "씨뽤",
  "씨뽥",
  "씨뿔",
  "씨쁠",
  "씨섹끼",
  "씨앙",
  "씨앙넘",
  "씨앙년",
  "씨앙놈",
  "씨앙눔",
  "씨양넘",
  "씨양년",
  "씨양념",
  "씨양놈",
  "씨양눔",
  "씨이댕",
  "씨이바",
  "씨이발",
  "씨이방",
  "씨이밸",
  "씨이뱅",
  "씨이벌",
  "씨이불",
  "씨이붕",
  "씨이빡",
  "씨이빨",
  "씨이이팔",
  "씨이팔",
  "씨이펄",
  "씨이풀",
  "씨입년",
  "씨입뇬",
  "씨입쉐",
  "씨입팔",
  "씨입할",
  "씨잘",
  "씨키",
  "씨탱",
  "씨탱구리",
  "씨텡",
  "ㅆㅣㅍㅏ",
  "씨파넘",
  "씨파늠",
  "씨파알",
  "씨파야",
  "씨팍",
  "씨팍년",
  "씨팍놈",
  "씨팍늠",
  "씨팍새꺄",
  "씨팍새끼",
  "씨팍세끼",
  "씨팏",
  "씨팔",
  "씨팔넘",
  "씨팔년",
  "씨팔놈",
  "씨팔뇬",
  "씨팔뇸",
  "씨팔허접",
  "씨팕",
  "씨팗",
  "씨팞",
  "씨팡",
  "씨퍌",
  "ㅆㅣㅍㅓ",
  "씨펄",
  "씨펄년",
  "씨펄놈",
  "씨펄운영자",
  "씨펑",
  "씨퐁",
  "씨퐁넘",
  "씨퐁뇬",
  "씨퐁보지",
  "씨퐁자지",
  "씨퐈",
  "씨풀",
  "씨풍",
  "씨플",
  "씨필",
  "씨할",
  "씨ㅡ발",
  "씨ㅣ발",
  "씰알",
  "씳박",
  "씳발",
  "씳알",
  "씹8",
  "씹가튼",
  "씹갓길",
  "씹개",
  "씹구멍",
  "씹까",
  "씹넘",
  "씹녀",
  "씹년",
  "씹년운영자",
  "씹놈",
  "씹뇬",
  "씹뇸",
  "씹딱구리",
  "씹딱꾸리",
  "씹딱꿍",
  "씹때",
  "씹때꺄",
  "씹때끼",
  "씹땡",
  "씹땡구리",
  "씹떼",
  "씹떼끼",
  "씹물",
  "씹미랄",
  "씹발",
  "씹발년",
  "씹발놈",
  "씹밸",
  "씹버지",
  "씹벌",
  "씹보지",
  "씹보지년",
  "씹볼뇬",
  "씹부랄",
  "씹브랄",
  "씹블",
  "씹빠",
  "씹빠빠",
  "씹빡",
  "씹빨",
  "씹빨넘",
  "씹빨놈",
  "씹빵구",
  "씹뻘",
  "씹뽀지",
  "씹뽕",
  "씹사꾸",
  "씹새",
  "씹새꺄",
  "씹새끼",
  "씹새리",
  "씹새캬",
  "씹새키",
  "씹색기",
  "씹색꺄",
  "씹색끼",
  "씹색히",
  "씹샛길",
  "씹생",
  "씹생년",
  "씹생알",
  "씹세",
  "씹세끼",
  "씹세리",
  "씹셋나루",
  "씹쇄",
  "씹숑",
  "씹쉐",
  "씹쉐리",
  "씹쉐키",
  "씹쉑",
  "씹쉑히",
  "씹스",
  "씹시끼",
  "씹쌍",
  "씹쌔",
  "씹쌔기",
  "씹쌔꺄",
  "씹쌔끼",
  "씹쌔리",
  "씹쌔키",
  "씹쌕끼",
  "씹쎄",
  "씹쎄끼",
  "씹쎄리",
  "씹쎈찌",
  "씹쐐",
  "씹쒜",
  "씹쓰",
  "씹씨키",
  "씹알",
  "씹알넘",
  "씹에",
  "씹연",
  "씹을넘",
  "씹을년",
  "씹을놈",
  "씹을뇬",
  "씹자석",
  "씹자슥",
  "씹자식",
  "씹자지",
  "씹자지년",
  "씹장이",
  "씹쟁이",
  "씹주구리",
  "씹지랄",
  "씹지럴",
  "씹질",
  "씹찔",
  "씹창",
  "씹창녀",
  "씹창년",
  "씹처",
  "씹쳐",
  "씹치남",
  "씹탱",
  "씹탱구리",
  "씹탱굴이",
  "씹탱꾸리",
  "씹탱이",
  "씹털",
  "씹텡",
  "씹텡구리",
  "씹퉁",
  "씹팅",
  "씹팔",
  "씹팔넘",
  "씹팔년",
  "씹팔놈",
  "씹팔뇬",
  "씹팔련",
  "씹팔연",
  "씹퍼년",
  "씹펄",
  "씹풀",
  "씹할",
  "씹할넘",
  "씹할년",
  "씹할놈",
  "씹할뇬",
  "씹할연",
  "씹헐",
  "씺",
  "씻끼",
  "씻발",
  "씻벌",
  "씻뻘",
  "씻탱구리",
  "씻팔",
  "씻퐁",
  "씾팔",
  "앂년",
  "ㅆI",
  "ㅆI발",
  "ㅆI팔",
  "ㅆL",
  "ㅆl발",
  "ㅆl팔",
  "아가리",
  "아가리닥쳐",
  "아씹",
  "안에사정",
  "알몸",
  "애널",
  "애널입4",
  "애무",
  "애미",
  "애미랄",
  "애미보지",
  "애미씨뱅",
  "애미자지",
  "애미잡년",
  "애미좃물",
  "애비",
  "애자",
  "앰병",
  "앰창",
  "양아치",
  "양키",
  "얨병",
  "어미강간",
  "어미따먹자",
  "어미쑤시자",
  "엄마젓",
  "엄마젖",
  "엄창",
  "에미",
  "에미젓",
  "에미창",
  "에비",
  "엔플레버",
  "엠병",
  "엠창",
  "엠플레버",
  "여엄병",
  "연병",
  "연븅",
  "연빙",
  "염별할년",
  "염병",
  "염병할",
  "염병할년",
  "염병할뇬",
  "염병할욘",
  "염뵹",
  "염소새끼호로",
  "엿먹구뒤져라",
  "엿먹어",
  "엿먹어라",
  "영자",
  "옘병",
  "오나니",
  "오랄",
  "오럴",
  "오르가슴",
  "오르가줌",
  "오르가즘",
  "오빠아파",
  "오빠아퍼",
  "오빠흘러내려",
  "오입",
  "올가슴",
  "올가즘",
  "왕버지",
  "왕보지",
  "왕부랄",
  "왕자지",
  "왕잠지",
  "왕좃",
  "왕털버지",
  "왕털보지",
  "왕털자지",
  "왕털잠지",
  "왜놈",
  "요씨댕",
  "욘병",
  "욘뵹",
  "욘븅",
  "욤뵹",
  "우라질",
  "우라질년",
  "우미쑤셔",
  "운디네",
  "운영자",
  "운영자개새끼",
  "운영자미친놈",
  "운영자씨발놈",
  "유깝",
  "유깦",
  "유두",
  "유두빨어",
  "유두핧어",
  "유방",
  "유방만져",
  "유방빨아",
  "유방주물럭",
  "유방쪼물딱",
  "유방쪼물럭",
  "유방핧아",
  "유방핧어",
  "유욱갑",
  "육갑",
  "육갑떠",
  "육갑떨",
  "육갚",
  "육구자세",
  "육깝",
  "육깦",
  "육봉",
  "육시랄",
  "육시럴",
  "육실할",
  "육실헐",
  "음경",
  "음모",
  "음순",
  "이그니스",
  "이년",
  "이프리트",
  "임빙할",
  "입사후장",
  "입안사정",
  "ㅈ",
  "ㅈ1랄",
  "ㅈㄲ",
  "ㅈㄹ",
  "ㅈㅏ★우",
  "자궁",
  "자기핥아",
  "자기핧아",
  "자댕이들",
  "자슬아치",
  "자아위",
  "자아지",
  "자아지털",
  "ㅈㅏ우ㅣ",
  "자위",
  "자위중",
  "자위행위",
  "자쥐",
  "자쥣",
  "자지",
  "자지구녕",
  "자지구멍",
  "자지꽂아",
  "자지넣자",
  "자지년",
  "자지때",
  "자지뜨더",
  "자지뜯어",
  "자지박어",
  "자지빨아",
  "자지빨아줘",
  "자지빨어",
  "자지쑤셔",
  "자지쓰레기",
  "자지정개",
  "자지짤라",
  "자지털",
  "자지핧아",
  "자지핧아줘",
  "자지핧어",
  "작은보지",
  "잘빨아",
  "잠쥐",
  "잠쥐털",
  "잠지",
  "잠지뚫어",
  "잠지물마셔",
  "잠지털",
  "잠짓물마셔",
  "잡것",
  "잡껏",
  "잡냔",
  "잡너무",
  "잡넘",
  "잡년",
  "잡노무",
  "잡놈",
  "잡놉",
  "잡뇬",
  "잡뇸",
  "잡밥",
  "잡시퀴",
  "잡시키",
  "잡탱년",
  "잦이",
  "잦털",
  "자g",
  "자ji",
  "자x",
  "재랄",
  "쟈지",
  "쟘쥐",
  "ㅈㅓㄲㅏ",
  "저까라마이신",
  "저까라마이씽",
  "저까운영자",
  "저까튼",
  "저까튼년",
  "저꽈튼",
  "저꽛튼",
  "저년",
  "저떠씨벵",
  "ㅈㅓㅃㅏ",
  "저빠지게",
  "저빱",
  "적가튼",
  "적까쥐",
  "적까지",
  "적꽈튼",
  "적셔줄",
  "전나",
  "전니",
  "전만싀끼",
  "전만한",
  "젇놔",
  "젇만",
  "절나",
  "절대지존좃밥",
  "절라",
  "점물",
  "접밥",
  "젓가튼",
  "젓가튼쉐이",
  "젓갓",
  "젓같",
  "젓같내",
  "젓같은",
  "젓같은놈",
  "젓까",
  "젓나",
  "젓냄새",
  "젓니",
  "젓대가리",
  "젓더",
  "젓떠",
  "젓떨",
  "젓또",
  "젓마",
  "젓마무리",
  "젓만",
  "젓만이",
  "젓물",
  "젓물냄새",
  "젓밥",
  "젓밮",
  "젓빠",
  "젓빱",
  "젓빺",
  "젓뺑이",
  "젓소부랄",
  "젓잡고",
  "젓카",
  "정사",
  "정액마셔",
  "정액먹어",
  "정액발사",
  "정액짜",
  "정액핧아",
  "정자마셔",
  "정자먹어",
  "정자핧아",
  "젖가",
  "젖같",
  "젖같은",
  "젖까",
  "젖나",
  "젖나게",
  "젖대가리",
  "젖더",
  "젖도",
  "젖디",
  "젖떠",
  "젖떨",
  "젖또",
  "젖마난",
  "젖마니",
  "젖만",
  "젖밥",
  "젖밮",
  "젖빠",
  "젖빱",
  "젖빺",
  "젖은숲",
  "젖잡고",
  "젖치기",
  "젖탱이",
  "젖통",
  "젗같",
  "젗까",
  "젗만",
  "젗밥",
  "젗밮",
  "젗빱",
  "젗빺",
  "젗잡고",
  "젙니",
  "ㅈㅕㄲㅏ",
  "져꽈튼",
  "져더",
  "젼마니",
  "졋같다",
  "졋더",
  "졎같다",
  "조가비",
  "조가튼",
  "조가틍",
  "조개넓은년",
  "조개따조",
  "조개마셔줘",
  "조개벌려조",
  "조개속물",
  "조개쑤셔줘",
  "조개핧아줘",
  "조까",
  "조깐다",
  "조깓",
  "조깟",
  "조깠",
  "조깥",
  "조끗",
  "조나빡가",
  "조내",
  "조낸",
  "조刀ㅏ",
  "조또",
  "조랄",
  "조뢀",
  "조빠",
  "조빨",
  "조빱",
  "조빺",
  "조빼",
  "조뺑",
  "조뻬",
  "조뼁",
  "조삐리",
  "조오까",
  "조오또",
  "조오옷",
  "조옥같네",
  "조온나",
  "조옷",
  "조옷같",
  "조옷나",
  "조옷밥",
  "조옺",
  "ㅈㅗㅈ",
  "조쟁이",
  "조젱이",
  "조짜",
  "조ㅊ",
  "조카툰",
  "조털",
  "조토",
  "족가튼",
  "족간네",
  "족같",
  "족같내",
  "족같은넘",
  "족까",
  "족까내",
  "족딸",
  "족밥",
  "족빠",
  "족빼",
  "족뺑",
  "족뼁",
  "족짜",
  "졳",
  "존나",
  "존나게",
  "존내",
  "존네",
  "존년",
  "존니",
  "존마",
  "존마난",
  "존만",
  "존망",
  "존맹구",
  "존먹어",
  "존희",
  "졷",
  "졷가",
  "졷까",
  "졷나",
  "졷내",
  "졷네",
  "졷놔",
  "졷따",
  "졸라",
  "좀마난",
  "좀마니",
  "좀만아",
  "좀만한",
  "좀물",
  "좀쓰레기",
  "좁년",
  "좁밥",
  "좁밥운영자",
  "좁빠라라",
  "좁빱",
  "좃",
  "좃_",
  "좃!",
  "좃~",
  "좃가",
  "좃가튼",
  "좃가튼뇬",
  "좃간년",
  "좃갔",
  "좃같",
  "좃까",
  "좃까리",
  "좃깐",
  "좃깔",
  "좃깟",
  "좃깟네",
  "좃깠",
  "좃꼴리",
  "좃꼴린",
  "좃나",
  "좃나개",
  "좃나게",
  "좃나씹",
  "좃냄새",
  "좃넘",
  "좃대가리",
  "좃도",
  "좃떠",
  "좃또",
  "좃마나",
  "좃마난",
  "좃마니",
  "좃만",
  "좃만나",
  "좃만아",
  "좃만안그지",
  "좃만이",
  "좃만한",
  "좃만한것",
  "좃만한년",
  "좃만한놈",
  "좃만한쉐이",
  "좃맨",
  "좃물",
  "좃물냄새",
  "좃박사",
  "좃발",
  "좃밥",
  "좃밮",
  "좃뱅",
  "좃병신",
  "좃보지",
  "좃부랄",
  "좃빠",
  "좃빠구리",
  "좃빠네",
  "좃빠라라",
  "좃빤",
  "좃빨",
  "좃빱",
  "좃빺",
  "좃빼",
  "좃뺑",
  "좃뻬",
  "좃뼁",
  "좃뽄",
  "좃삐",
  "좃쌍",
  "좃에피나",
  "좃이나빨어",
  "좃짜",
  "좃탱",
  "좃터는",
  "좃털",
  "좄ㄲㅏ",
  "종간나",
  "좆",
  "좆_",
  "좆!",
  "좆~",
  "좆같",
  "좆같은놈",
  "좆같은새끼",
  "좆까",
  "좆까라",
  "좆꺄튼년",
  "좆꼴려",
  "좆나",
  "좆년",
  "좆니",
  "좆대",
  "좆대가리",
  "좆도",
  "좆또",
  "좆마난",
  "좆마니",
  "좆만",
  "좆만아",
  "좆만한",
  "좆만한년",
  "좆만한놈",
  "좆만한새끼",
  "좆먹어",
  "좆물",
  "좆밥",
  "좆병신",
  "좆비비",
  "좆빠",
  "좆빠라",
  "좆빤",
  "좆빨",
  "좆빨아",
  "좆빱",
  "좆빺",
  "좆빼",
  "좆뺑",
  "좆뻬",
  "좆뼁",
  "좆삐리",
  "좆새끼",
  "좆쑤시",
  "좆짜",
  "좆짜라",
  "좆탱",
  "좆터",
  "좆털",
  "좇",
  "좇_",
  "좇!",
  "좇~",
  "좇가",
  "좇같",
  "좇까",
  "좇나",
  "좇대",
  "좇대가리",
  "좇도",
  "좇또",
  "좇만",
  "좇밥",
  "좇밮",
  "좇빠",
  "좇빨",
  "좇빱",
  "좇빺",
  "좇삐리",
  "좉",
  "좉까",
  "좉나",
  "좉빨",
  "좋까",
  "좋만한",
  "좋만한것",
  "좌지",
  "좝것",
  "죄랄",
  "죠까틍",
  "죠또",
  "죠빠",
  "죠카태",
  "죠카테",
  "죠카툰",
  "죠콰떼",
  "죠콰태",
  "죠콰테",
  "죠콰퉤",
  "죤나",
  "죤뇬",
  "죤니",
  "죤만년",
  "죤만놈",
  "죧같",
  "죨리",
  "죳",
  "죳까",
  "죳나",
  "죳밥",
  "죳삐리",
  "죴",
  "죵나",
  "죵늬",
  "죶",
  "죶가튼",
  "죶같은",
  "죶나",
  "죶니",
  "죶마난",
  "죶빠",
  "죷",
  "죷까",
  "죹",
  "주글년",
  "주길년",
  "주딩이",
  "줒나",
  "줟",
  "쥐랄",
  "쥐랼",
  "쥐럴",
  "쥐롤",
  "쥐뢀",
  "쥐미",
  "쥐이럴",
  "쥐좆",
  "쥘알",
  "쥘얼",
  "즈랄",
  "즈럴",
  "즤랄",
  "즤랅",
  "즤랼",
  "즤롤",
  "즤뢀",
  "즤미럴",
  "지구멍",
  "ㅈㅣㄹㅏ",
  "지라알",
  "지랄",
  "지랄발광",
  "지랄삽차기",
  "지랄쌈치기",
  "지랄육갑",
  "지랗",
  "지랠",
  "지랼",
  "ㅈㅣㄹㅓ",
  "지럴",
  "지럴발광",
  "지렐",
  "지롤",
  "지롤발광",
  "지뢀",
  "지룔",
  "ㅈㅣ룰",
  "지미랄",
  "지미럴",
  "지이라알",
  "지이랄",
  "지이럴",
  "지좆",
  "질내사정",
  "질사정",
  "질알",
  "질질싸",
  "질할",
  "ㅈI랄",
  "ㅈL랄",
  "짜쥐",
  "짜지",
  "짝부랄",
  "짬지",
  "짭것",
  "짭년",
  "짭놈",
  "짭뇬",
  "짱깨",
  "짱꼴라",
  "쩝밥",
  "쩝쩝훑훑",
  "쩤밥",
  "쪼가튼",
  "쪼ㄲㅏ",
  "쪼까튼",
  "쪼다",
  "쪼다새끼",
  "쪼빠라",
  "쪼빤다",
  "쪼ㅆ",
  "쪼ㅈ",
  "쪽바리",
  "쫀ㄴㅏ",
  "쫃갇네",
  "쫃같네",
  "쫍밥",
  "쫍빱",
  "쫏",
  "쫒",
  "쫓까",
  "쬬까",
  "쬬또",
  "쯰랄",
  "쯰롤",
  "찌랄",
  "찌롤",
  "ㅉㅣㅈㅕ",
  "찌질이",
  "찐따",
  "찢어벌",
  "찢어죽",
  "찢어죽일년",
  "차앙년",
  "창남",
  "창넘",
  "창녀",
  "창녀버지",
  "창녀촌",
  "창년",
  "창놈",
  "창뇬",
  "창ㅇ년",
  "창질",
  "챵년",
  "챵뇬",
  "처녀막",
  "처먹고",
  "처먹어",
  "처먹을",
  "처죽일년",
  "처죽일놈",
  "첫경험",
  "첫날밤하는거",
  "체모",
  "체위",
  "쳐먹고",
  "쳐쑤셔박어",
  "쳐죽인",
  "쳐죽일",
  "쳐죽일것",
  "쳐죽일년",
  "쳐죽일놈",
  "초딩새끼",
  "촌나시펄",
  "촌씨브",
  "촌씨브라리",
  "촌씨브랑이",
  "촌씨브랭이",
  "촹년",
  "촹뇬",
  "취럴",
  "칀넘아",
  "칙쇼",
  "칭챙총",
  "칭총",
  "카섹",
  "카섹스",
  "카쎅",
  "카x",
  "캐년",
  "캐뇬",
  "캐새끼",
  "캐새키",
  "캐세끼",
  "캐셋키",
  "캐쉐리",
  "커엄새액",
  "커엄새엑",
  "커엄세액",
  "커엄세엑",
  "컴색",
  "컴세엑",
  "컴섹",
  "컴섹스",
  "컴쌕",
  "컴쎅",
  "컴s",
  "컴x",
  "케뇬",
  "케새",
  "케새끼",
  "케새킹",
  "케세",
  "케세끼",
  "코쟁이",
  "크리토리스",
  "큰보지",
  "클리토리스",
  "큼섹",
  "탱구리",
  "털지갑",
  "트랜스젠더",
  "팔넘",
  "팔년",
  "팔놈",
  "팔뇬",
  "패니스",
  "퍼큐",
  "퍽유",
  "퍽큐",
  "펀색",
  "펀섹",
  "펄넘",
  "펄년",
  "펄놈",
  "펄뇬",
  "펔뀨",
  "펔유",
  "페니스",
  "페미나치",
  "페미년",
  "페미련",
  "페팅",
  "포르노",
  "포온섹",
  "폰떽",
  "폰색",
  "폰섹",
  "폰섹?스",
  "폰섹스",
  "폰쉑",
  "폰쌕",
  "폰쎅",
  "폰s",
  "폰x",
  "풋잡",
  "한남소추",
  "한남유충",
  "한남충",
  "한유남충",
  "할넘",
  "할년",
  "할놈",
  "할뇬",
  "할타",
  "핥아",
  "함대주까",
  "함대줄까",
  "함대줄래",
  "함빨자",
  "함주까",
  "항문수셔",
  "항문쑤셔",
  "허덥",
  "허버리년",
  "허버허버",
  "허벌년",
  "허벌보지",
  "허벌자식",
  "허벌자지",
  "허벌창",
  "허접",
  "허젚",
  "허졉",
  "허좁",
  "헐넘",
  "헐년",
  "헐놈",
  "헐렁보지",
  "혀로보지핧기",
  "혜지년",
  "혜지련",
  "호냥년",
  "호냥뇬",
  "호래자",
  "호레",
  "호로",
  "호로개자슥",
  "호로개잡늠",
  "호로년",
  "호로뇬",
  "호로새",
  "호로새꺄",
  "호로새끼",
  "호로색",
  "호로쉑",
  "호로쌔꺄",
  "호로오",
  "호로자",
  "호로자슥",
  "호로자식",
  "호로잡",
  "호로짜식",
  "호롸",
  "호루자슥",
  "호모",
  "호모섹",
  "호모쉐이",
  "호모쌕",
  "호모쎄끼",
  "호모자식",
  "호봉세씨",
  "호봉쎄끼",
  "호봉쒜리",
  "호양년",
  "호오로",
  "호졉",
  "호좁",
  "혼음",
  "홀오자식",
  "화냥",
  "화냥년",
  "화냥뇬",
  "화양년",
  "확벌",
  "확찌",
  "확찢",
  "후다년",
  "후라덜",
  "후라덜넘",
  "후라들년",
  "후라질",
  "후라질넘",
  "후라질년",
  "후래",
  "후래자",
  "후랴",
  "후러덜",
  "후레",
  "후레년",
  "후레발",
  "후레자",
  "후로자",
  "후릴년",
  "후배위",
  "후벼",
  "후비파",
  "후장",
  "후장꽂아",
  "후장뚫어",
  "후장입사",
  "흐접",
  "흐젚",
  "흐졉",
  "흑형",
  "히로뽕",
  "히밤",
  "ㅄ",
  "ac발",
  "ac팔",
  "anal",
  "annal",
  "anul",
  "arbeit macht frei",
  "Arsch",
  "Arschloch",
  "Arse",
  "Arsehole",
  "arseholes",
  "ass",
  "asshole",
  "assholes",
  "auschwitz",
  "ausschwitz",
  "Baiser",
  "Bangzi",
  "bbagoori",
  "bbagury",
  "Bellend",
  "bitch",
  "blow job",
  "Blowjob",
  "bo지",
  "bogy",
  "boji",
  "bojy",
  "Bollocks",
  "Bougnoul",
  "bozi",
  "bozy",
  "Bullshit",
  "bunsec",
  "bunsek",
  "buttfuck",
  "buttfucker",
  "C8넘",
  "C8년",
  "C8놈",
  "C8뇬",
  "c발넘",
  "c발년",
  "c발놈",
  "c발뇬",
  "c발섹",
  "c발쉑",
  "c벌넘",
  "C벌년",
  "c부랄",
  "c불넘",
  "c불놈",
  "c불늠",
  "c블넘",
  "c블놈",
  "c블늠",
  "c빨넘",
  "cabron",
  "CARSEX",
  "ching",
  "Chink",
  "Chinky",
  "chój",
  "chong",
  "chuj",
  "chwdp",
  "cipa",
  "cipo",
  "cipsko",
  "Cock",
  "cock sucker",
  "Cocks",
  "Cocksucker",
  "comepollas",
  "comepoyas",
  "Connard",
  "coño",
  "Cul",
  "Cum",
  "Cunt",
  "cunts",
  "cval",
  "czarnuch",
  "D랄",
  "Dick",
  "Dickhead",
  "Dicks",
  "dog새",
  "Drecksau",
  "drecksjude",
  "encular",
  "Enculé",
  "Endlösung",
  "Endsieg",
  "facha",
  "fag",
  "Faggot",
  "falangista",
  "fascista",
  "Fellatio",
  "Ferme ta gueule",
  "fick dich",
  "Fils de pute",
  "fistfuck",
  "Fiucie",
  "Fiut",
  "follada",
  "Fook",
  "Fooker",
  "Fooking",
  "Fotze",
  "Foutre",
  "foyada",
  "fuck",
  "Fucker",
  "Fuckers",
  "Fucking",
  "fuckyou",
  "Führer",
  "g랄",
  "g럴",
  "g롤",
  "g뢀",
  "g룰",
  "goatse",
  "Grosse merde",
  "heil hitler",
  "hijo Hitler",
  "hijo puta",
  "hijoputa",
  "Hitler",
  "ho로",
  "hoj",
  "hój",
  "huj",
  "HWDP",
  "ja위",
  "ja지",
  "jaji",
  "jamji",
  "Japseye",
  "jawe",
  "jawi",
  "jazi",
  "jazy",
  "jebać",
  "jebanie",
  "jebca",
  "jilipollas",
  "jiral",
  "Jizz",
  "joder",
  "jot",
  "judenmutter",
  "judensöhne",
  "Kike",
  "korwa",
  "kórwa",
  "kurwa",
  "kurwia",
  "kurwiszon",
  "kutafon",
  "kutas",
  "leck mich",
  "mamada",
  "mamado",
  "mamarla",
  "masterbat",
  "mastorbat",
  "masturbat",
  "mentor",
  "mineciarz",
  "Mong",
  "moraco",
  "mother fuck",
  "motherfuck",
  "motherfucker",
  "Motherfucking",
  "Nazi",
  "neger",
  "negrata",
  "Nègre",
  "negrero",
  "negro",
  "nekrofil",
  "nflavor",
  "Nigga",
  "Nigger",
  "niggers",
  "nigimi",
  "Niquer",
  "odbyt",
  "odjebało",
  "odpierdol",
  "orgasm",
  "pajear",
  "pajote",
  "Paki",
  "pakis",
  "panchito",
  "panis",
  "pedal",
  "pedał",
  "Pédé",
  "pederasta",
  "pedofila",
  "pedófila",
  "pen!s",
  "penis",
  "pennis",
  "PHONE색",
  "PHONESEC",
  "phonesex",
  "PHONSEC",
  "phonsek",
  "pierdol",
  "pierdolic",
  "pierdolić",
  "pierdolona",
  "pizda",
  "polla",
  "ponsec",
  "ponsek",
  "porn",
  "porno",
  "poya",
  "Prick",
  "Pricks",
  "prostitu",
  "prostituir",
  "proxeneta",
  "przejebane",
  "przyjeb",
  "pussy",
  "puta",
  "Putain",
  "Pute",
  "Queer",
  "racist",
  "racista",
  "raecarruth",
  "raghead",
  "ragheads",
  "rallig",
  "ramera",
  "rammeln",
  "Rape",
  "Rapist",
  "rassenlehre",
  "rattig",
  "reichskristall",
  "reisfresser",
  "renob",
  "rentafuck",
  "retrasada",
  "retrasado",
  "reubeu",
  "ril",
  "rimjob",
  "rimming",
  "rital",
  "roach",
  "robber",
  "rosbif",
  "rosette",
  "rozpierdalać",
  "rozpierdolone",
  "rozpierdolony",
  "ruchać",
  "ruchanie",
  "ruhać",
  "ruhanie",
  "rula",
  "ruski",
  "ruskoff",
  "ruskov",
  "s-c-v-m",
  "s.hit",
  "s&m",
  "s1ut",
  "s하고e싶다x",
  "sackgesicht",
  "sadismo",
  "sado-masochistic",
  "sadomaso",
  "sadomasochistic",
  "sadomasoquismo",
  "sadomasoquista",
  "salop",
  "salopard",
  "salope",
  "samckdaddy",
  "samen",
  "sandm",
  "sandnigger",
  "sarasa",
  "sarracena",
  "sarraceno",
  "satan",
  "saubeutel",
  "sauhund",
  "sausagejockey",
  "sc*m",
  "scat",
  "schamhaar",
  "scheiss",
  "schlampe",
  "schleu",
  "schleuh",
  "schlitzauge",
  "schlong",
  "schutzstaffel",
  "schwanz",
  "Schwanzlutscher",
  "schwuchtel",
  "scrote",
  "scum",
  "scum!",
  "se엑스",
  "semen",
  "sex",
  "SEX로리타",
  "sh!t",
  "sh!te",
  "sh!tes",
  "sh1't",
  "sh1t",
  "sh1te",
  "sh1thead",
  "sh1theads",
  "shadybackroomdealings",
  "shadydealings",
  "Shag",
  "shaggers",
  "shaggin",
  "shagging",
  "shat",
  "shawtypimp",
  "sheep-l0ver",
  "sheep-l0vers",
  "sheep-lover",
  "sheep-lovers",
  "sheep-shaggers",
  "sheepl0ver",
  "sheepl0vers",
  "sheeplover",
  "sheepshaggers",
  "sheethead",
  "sheetheads",
  "sheister",
  "shhit",
  "Shit",
  "shít",
  "shit4brains",
  "shitass",
  "shitbag",
  "shitbagger",
  "shitbrains",
  "shitbreath",
  "shitcunt",
  "shitdick",
  "shiteater",
  "shited",
  "shitface",
  "shitfaced",
  "shitforbrains",
  "shitfuck",
  "shitfucker",
  "shitfull",
  "shithapens",
  "shithappens",
  "shithead",
  "shithole",
  "shithouse",
  "shiting",
  "shitings",
  "shitoutofluck",
  "shits",
  "shitspitter",
  "shitstabber",
  "shitstabbers",
  "shitstain",
  "shitted",
  "shitter",
  "shitters",
  "shittiest",
  "shitting",
  "shittings",
  "shitty",
  "shiz",
  "shiznit",
  "shortfuck",
  "shyte",
  "SIBALNYUN",
  "sieg heil",
  "sinnfein",
  "sinnfein's",
  "skeet",
  "skorwiel",
  "skórwiel",
  "skullfuck",
  "Skurwiel",
  "slag",
  "slanderyou2.blogspot.com",
  "slanteye",
  "Slut",
  "slutbag",
  "sluts",
  "slutt",
  "slutting",
  "slutty",
  "slutwear",
  "slutwhore",
  "smackdaddy",
  "smackthemonkey",
  "smagma",
  "smartass",
  "smeg",
  "snortingcoke",
  "sodomizar",
  "sonofabitch",
  "sonofbitch",
  "soplapollas",
  "Spacka",
  "Spast",
  "Spasten",
  "Spasti",
  "Spaz",
  "Spunk",
  "Spunkbubble",
  "sranie",
  "ssang",
  "subnormal",
  "sudaca",
  "Te faire enculer",
  "Tranny",
  "Twat",
  "verga",
  "vergasen",
  "violar",
  "Violer",
  "Wank",
  "Wanker",
  "wyjebac",
  "wyjebany",
  "wyjebć",
  "wypierdol",
  "x섹x스x해x",
  "x위",
  "x지",
  "XX할",
  "yangkee",
  "zajebać",
  "zajebane",
  "zajebany",
  "zaji",
  "zazi",
  "zazy",
  "zot",
];

export default profanities;